// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.material-menubar .MuiButtonBase-root:last-child {
    margin-right: 0.5rem;
    margin-left: 0.5rem;
}

.truncated {
    max-width: 250px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

button[aria-pressed="true"] {
    background-color: rgba(0, 0, 0, 0.04);
}`, "",{"version":3,"sources":["webpack://./../editor/src/components/app-bar/styles.css"],"names":[],"mappings":";AACA;IACI,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,qCAAqC;AACzC","sourcesContent":["\n.material-menubar .MuiButtonBase-root:last-child {\n    margin-right: 0.5rem;\n    margin-left: 0.5rem;\n}\n\n.truncated {\n    max-width: 250px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\nbutton[aria-pressed=\"true\"] {\n    background-color: rgba(0, 0, 0, 0.04);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
